import React, { useEffect, useState } from "react";
import { Row, Col, Spinner, Alert } from "react-bootstrap";
import apiCall from "../Api/api";
import parse from 'html-react-parser';


const AboutIntro = () => {
  const [aboutContent, setPAboutContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        setLoading(true);
        const response = await apiCall({
          url: `about-us`,
          method: "GET",
          headers: "",
        });

        if (response?.status === 200) {
          setPAboutContent(response?.data?.content);
        } else {
          throw new Error("Failed to load terms. Please try again.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAbout();
  }, []);
  return (
    <section className="terms_wrapper">
      <div className="container-lg">
        <Row className="pb-5 margin_bottomfooter justify-content-center">
          <Col xs={12}>
            <div className="title_terms">
              <h2>About Us</h2>
            </div>
          </Col>

          <Col lg={8} md={10}>
            <div className="terms_details text-center">
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" style={{ color: "#09422d" }} />
                </div>
              ) : error ? (
                <Alert variant="danger">{error}</Alert>
              ) : (
                <>
                  {aboutContent && parse(aboutContent)}
                </>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default AboutIntro;
